import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { useIntl, useSelector } from "@grandvisionhq/state";
import "../../../../../../../../../../state/state/actions.js";
import "../../../../../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../../../../../state/bundles/state/bundles/reducer.js";
import { getPrescriptionType } from "../../../../../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../../../../../state/products/state/products/selectors.js";
import "../../../../../../../../../../state/products/state/products/reducer.js";
import { isNewPrescriptionAndUpload } from "../../../../../../../../../../utils/utils/is-new-prescription-upload.js";
import { PupillaryDistanceExternalLink } from "./PupillaryDistanceExternalLink.js";
const PupillaryDistanceExternalLinkContainer = ({ className }) => {
  const { hasLabel, getFormattedLabel } = useIntl();
  const prescriptionType = useSelector(getPrescriptionType);
  const pdLinkLabelKey = CommerceToolsApi.isPrescriptionFile(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType) ? "products.glasses.prescription.form.pdMeasurementLink" : "products.glasses.prescription.form.pdLink";
  const handleClick = () => {
    DataLayer.Events.pushDrawerEventToDataLayer({
      siteFeature: "rxconfigurator",
      interactionType: "how_to_measure_pupillary_distance_click"
    });
  };
  const pdLinkLabel = React.useMemo(() => {
    if (!hasLabel(pdLinkLabelKey)) {
      return null;
    }
    const formattedLabel = getFormattedLabel(pdLinkLabelKey, {
      parseLink: true,
      parseHTML: true,
      openLinksInNewTab: true
    });
    if (!React.isValidElement(formattedLabel)) {
      return formattedLabel;
    }
    return React.cloneElement(formattedLabel, { onClick: handleClick });
  }, [getFormattedLabel, hasLabel, pdLinkLabelKey]);
  if (!pdLinkLabel) return null;
  return /* @__PURE__ */ React.createElement(PupillaryDistanceExternalLink, { className, pdLinkLabel });
};
export {
  PupillaryDistanceExternalLinkContainer
};
//# sourceMappingURL=PupillaryDistanceExternalLinkContainer.js.map
